import { REQUEST_STATUSES } from "@/constants/index.js";

import * as types from "./types.js";

const initialState = {
  element: {},
  status: REQUEST_STATUSES.IDLE,
  err: null,
};

export const currentElementReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CURRENT_ELEMENT:
      return { ...state, ...action.payload };
    case types.REFRESH_CURRENT_ELEMENT:
      return { ...state, element: { ...action.payload } };
    case types.SET_CURRENT_ELEMENT_REQUEST_STATUS:
      return { ...state, ...action.payload };
    case types.RESET_CURRENT_ELEMENT:
      return { ...initialState };
    default:
      return state;
  }
};
